
import './HeroSection.css';
import videoFile from '../../assets/images/demo2.MP4';

const HeroSection = () => {
    return (
        <div className="hero-container">
            <video autoPlay loop muted playsInline className="hero-video" preload="none">
                <source src={videoFile} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="hero-overlay"></div>
            <div className="hero-content-constraint">
                <div className="hero-content fade-in">
                    <h1 className="hero-title">
                        Crafting Excellence in <br /> Every Stitch
                    </h1>
                    <div className="hero-separator"></div>
                    <p className="hero-subtitle">Cut for the Gentlemen</p>

                </div>


                <div className="hero-btn-wrapper">
                    <button className="hero-btn" onClick={() => { window.location.href = 'tel:09909102266' }}>BOOK A FITTING</button>
                </div>
            </div>


        </div>
    );
};

export default HeroSection;
